import { BuscaCidadaoListagemTematicaSaudeMulherQuery } from 'graphql/types.generated'

export type CidadaoListagemSaudeMulherQueryResult = BuscaCidadaoListagemTematicaSaudeMulherQuery['acompanhamentoCondicaoSaude']
export type CidadaoListagemSaudeMulherQueryModel = CidadaoListagemSaudeMulherQueryResult['content'][0]

export type SaudeMulherResultadoExameModel = CidadaoListagemSaudeMulherQueryModel['cidadao']['cidadaoConsolidado']['saudeMulher']['ultimaAvaliacaoCancerMama'] &
  CidadaoListagemSaudeMulherQueryModel['cidadao']['cidadaoConsolidado']['saudeMulher']['ultimaSolicitacaoCancerMama'] &
  CidadaoListagemSaudeMulherQueryModel['cidadao']['cidadaoConsolidado']['saudeMulher']['ultimaRealizacaoCancerMama']

export type SaudeMulherResultadoExameProcedimentoModel = CidadaoListagemSaudeMulherQueryModel['cidadao']['cidadaoConsolidado']['saudeMulher']['ultimaSolicitacaoCancerColoUtero'] &
  CidadaoListagemSaudeMulherQueryModel['cidadao']['cidadaoConsolidado']['saudeMulher']['ultimaAvaliacaoCancerColoUtero']

export const IDADE_FORA_DE_RASTREIO_TEXT = 'Fora da idade para rastreio.'
